 <determinant-new *ngIf="store.state.common.determinantSection.topLayer === 'edit'"
                  class="row layer sub-layer onTop-sub-layer"
                  id="newDetFromFormio"
                  [detElementId]="'newDetFromFormio'"
                  [serviceId]="serviceId"
                  [determinant]="store.state.common.determinantSection.determinant"
                  (formSubmit)="closeEdit()"
                  [isOnSubLayer]="true"
                  (editCancel)="closeEdit()"></determinant-new>
    <determinant-builder [jsonString]="formDeterminant.jsonDeterminant" [determinantValue]="formDeterminant.value"
                         [serviceId]="serviceId" [showSaveCancelRow]=false [readonly]=readonly
                         [determinantMapById]="determinantMapById"
                         (onSave)="saveDeterminant($event)" (onDeterminantValueSave)="saveDeterminantValue($event)">
    </determinant-builder>
<div class="fix-forms-bottom"></div>
<ng-content></ng-content>
